import { render, staticRenderFns } from "./LessonEditSkeletonLoader.vue?vue&type=template&id=590e6468&scoped=true&"
import script from "./LessonEditSkeletonLoader.vue?vue&type=script&lang=js&"
export * from "./LessonEditSkeletonLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e6468",
  null
  
)

export default component.exports